import { useCallback, useMemo, useState } from "react";

export type ServerSortOrder = "default" | "asc" | "desc";

/** نگهداری مرتب‌سازی سه‌حالته‌ی سروری برای فهرست‌های API. */
const useServerSorting = (resetPage?: () => void) => {
  const [sortBy, setSortBy] = useState<string | undefined>();
  const [sortOrder, setSortOrder] = useState<ServerSortOrder>("default");

  const onChange = useCallback(
    (nextSortBy: string | undefined, nextSortOrder: ServerSortOrder) => {
      setSortBy(nextSortBy);
      setSortOrder(nextSortOrder);
      resetPage?.();
    },
    [resetPage]
  );

  const params = useMemo(
    () =>
      sortOrder === "default"
        ? { sort_order: "default" as const }
        : { sort_by: sortBy, sort_order: sortOrder },
    [sortBy, sortOrder]
  );

  return { sortBy, sortOrder, onChange, params };
};

export default useServerSorting;
